import axios from 'axios';
import { get } from 'lodash';
// import { camelizeKeys, decamelizeKeys } from 'humps';

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

Axios.interceptors.response.use(
  async response => {
    // TODO: Implement this feature next version.
    // if (response.data && response.headers['content-type'] === 'application/json') {
    //   response.data = camelizeKeys(response.data);
    // }

    return response;
  },
  async error => {
    const errorResponse = get(error, 'response.data.code', null);

    if (errorResponse === 'token_not_valid') {
      localStorage.removeItem('token');
      localStorage.removeItem('roles');
      localStorage.removeItem('user');
      localStorage.removeItem('pos');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

// TODO: Implement this feature next version.
// Axios.interceptors.request.use(config => {
//   const newConfig = { ...config };

//   if (newConfig.headers['Content-Type'] === 'multipart/form-data') return newConfig;

//   if (config.params) {
//     newConfig.params = decamelizeKeys(config.params);
//   }

//   if (config.data) {
//     newConfig.data = decamelizeKeys(config.data);
//   }

//   return newConfig;
// });

export default Axios;

export const fetcher = (url, option = {}) => Axios.get(url, option).then(res => res.data);
export const postFetcher = (url, data) => Axios.post(url, data).then(res => res.data);
export const putFetcher = (url, data) => Axios.put(url, data).then(res => res.data);
export const patchFetcher = (url, data) => Axios.patch(url, data).then(res => res.data);
export const deleteFetcher = (url, data) => Axios.delete(url, { data }).then(res => res.data);
